
import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpTaskType, OpTask } from "../models/core"
import { ColumnInfo } from "../models/custom"


export class DataProviderTaskType {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public deleteTaskType = (opObj: OpTaskType): JQueryPromise<void> => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteTaskType', { ToBeDeleted: opObj.toJSON() }, null)
    }

    public getTaskType = (id: number): JQueryPromise<OpTaskType> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetTaskType', { IdTaskType: id }, 'OpxGetTaskTypeResult')
            .then((response: Object) => {
                if (response != null) {
                    const result: OpTaskType = new OpTaskType(response)

                    OpTaskType.loadNavigationProperties(this.dataProvider, [result])

                    return result
                }

                return null
            })
    }

    public getTaskTypeFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpTaskType>([], 0, 0, '', Enums.ReferenceType.IdTaskType, 'OpxTaskTypeFilter', 'OpxTaskTypeFilterResult')
    }

    public saveTaskType = (taskType: OpTaskType): JQueryPromise<OpTaskType> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveTaskType', { ToBeSaved: taskType.toJSON() }, 'OpxSaveTaskTypeResult')
            .then((response: any) => {
                if (response != null) {
                    const result: OpTaskType = new OpTaskType(response)

                    OpTaskType.loadNavigationProperties(this.dataProvider, [result])

                    return result
                }

                return null
            })
    }

    // Public Methods End
}

